import React from "react";
import "./Clients.css";

import findUp from "../../assets/images/findUp.png";
import sgbr from "../../assets/images/logo-sgbr-og.png";
import maminfo from "../../assets/images/MAMINFO-LOGO.png";
import cocacola from "../../assets/images/coca-cola.png";
import weg from "../../assets/images/Weg_logo_blue_vector.svg.png";

const clients = [
  { src: cocacola, alt: "Cliente Coca-Cola" },
  { src: findUp, alt: "Cliente FindUp" },
  { src: sgbr, alt: "Cliente SGBR" },
  { src: maminfo, alt: "Cliente MAMINFO" },
  { src: weg, alt: "Cliente WEG" },
];

function Clients() {
  return (
    <section className="clients page-section" id="clients">
      <div className="section-container">
        <div className="section-header center">
          <span className="section-overline">Parcerias</span>
          <h2 className="section-title">Empresas que confiam na The Union Technology</h2>
          <p className="section-description">
            Cada logo representa um relacionamento sustentado por entregas consistentes, suporte próximo e confiança
            mútua na evolução tecnológica.
          </p>
        </div>

        <div className="clients__body surface-card">
          <div className="clients__intro">
            <span className="clients__tag">Cuidado com cada projeto</span>
            <h3 className="clients__subtitle">Parcerias estratégicas que valorizam resultado e continuidade</h3>
            <p>
              Atuamos ao lado das equipes internas para garantir disponibilidade, segurança e escalabilidade, sempre com
              planos personalizados de acompanhamento e evolução.
            </p>
            <ul className="clients__highlights">
              <li>Suporte especializado em todas as etapas do ciclo de vida da solução</li>
              <li>Integração cuidadosa com processos e equipes existentes</li>
              <li>Comunicação transparente e indicadores acompanhados de perto</li>
            </ul>

            <div className="clients__cta">
              <a className="primary-button" href="#contact">
                Quero conversar com o time
              </a>
              <a className="ghost-button" href="#services">
                Ver soluções oferecidas
              </a>
            </div>
          </div>

          <div className="clients__grid" role="list">
            {clients.map((client) => (
              <article className="client-card" key={client.alt} role="listitem">
                <div className="client-card__inner">
                  <div className="client-card__glow" aria-hidden="true" />
                  <img className="client-card__logo" src={client.src} alt={client.alt} loading="lazy" />
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Clients;
